import React, { Component } from "react";
import { Form, Input, Col, Row, Button, Modal, AutoComplete } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import debounce from "lodash/debounce";

import { apiCustomer } from "../../../../api/api-customer";
import { alert } from "../../../../common/utils/alert";

export class AddSubUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneUsers: [],
      confirmLoading: false,
      dataSource: [],
    };
  }

  setPhone = (phone, index) => {
    let country_code = "84";
    let iso2 = "vn";
    if (this[`phone${index}`]) {
      const { selectedCountry } = this[`phone${index}`].state;
      country_code = selectedCountry.dialCode;
      iso2 = selectedCountry.iso2;
    }
    const { phoneUsers } = this.state;
    let newPhones = [...phoneUsers];
    newPhones[index] = {
      ...newPhones[index],
      country_code,
      iso2,
      mobile: phone.replace(country_code, "").replace("+", ""),
    };

    this.setState({ phoneUsers: newPhones });
    //this.props.onChangeFormValues({ mobile: phone });
  };

  addPhoneUser = () => {
    const { phoneUsers } = this.state;
    let newPhones = [...phoneUsers];
    this.setState({
      phoneUsers: newPhones.concat({
        country_code: "84",
        mobile: "",
        iso2: "vn",
        isInContract: false,
      }),
    });
  };

  removePhoneUser = (index) => {
    const { phoneUsers } = this.state;
    let newPhones = [...phoneUsers];
    this.setState({
      phoneUsers: newPhones.filter((v, idx) => idx !== index),
    });
  };

  deleteSubUser = (index, callBack) => {
    const { phoneUsers } = this.state;
    if (!phoneUsers[index].id) {
      callBack();
      this.removePhoneUser(index);
      debounce(() => this.props.addUserSuggest(), 100)();
      return;
    }
    Modal.confirm({
      title: "Xóa user",
      icon: null,
      content:
        "Bạn có chắc chắn muốn xóa user này không? Nếu xóa những user thuộc quản lý của admin cũng bị xóa",
      okText: "Có",
      okType: "danger",
      cancelText: "Không",
      confirmLoading: this.state.confirmLoading,
      onOk: async () => {
        this.setState({ confirmLoading: true });

        apiCustomer
          .deleteCustomerEnterprise(phoneUsers[index].id)
          .then((response) => {
            this.setState({ confirmLoading: false });
            if (response.status === "success") {
              this.removePhoneUser(index);
              callBack();
              debounce(() => this.props.addUserSuggest(), 100)();
              alert("success", "Xóa user thành công!");
            } else {
              alert("error", response.data.message);
            }
          })
          .catch((err) => {
            this.setState({ confirmLoading: false });
          });
      },
      onCancel() {},
      className: "del-comfirm",
    });
  };

  onSearch = (value) => {
    if (this.props?.userParam?.member_customer_id) {
      apiCustomer
        .getSuggestMember({
          member_customer_id: this.props.userParam.member_customer_id,
          name: value,
        })
        .then((res) => {
          if (res.status === "success") {
            this.setState({
              dataSource: res.data.map((i) => ({
                text: i.name,
                value: i.name,
                ...i,
              })),
            });
          }
        });
    }
  };

  onSelect = (value, index) => {
    const findItem = this.state.dataSource.find((i) => i.text === value);
    if (findItem) {
      this.props.updateFieldUser(
        {
          // ...findItem,
          ...(!!findItem.code && { username: findItem.code }),
          ...(!!findItem.email && { email: findItem.email }),
          ...(!!findItem.mobile && { mobile: findItem.mobile }),
          ...(!!findItem.name && { name: findItem.name }),
          ...(!!findItem.department && { department: findItem.department }),
          ...(!!findItem.id && { id: findItem.id }),
          ...(!!findItem.code && { code: findItem.code }),
          is_new: false,
          role: "User",
        },
        index
      );
    }
  };

  render() {
    const { phoneUsers, dataSource } = this.state;
    const { editable, typeOption, disable } = this.props;

    return (
      <>
        <Form.List name="users">
          {(fields, { add, remove }) => {
            return (
              <div className="sub-user">
                {fields.map((field, index) => (
                  <div key={field.key}>
                    <div className="user-title">*User {index + 1}:</div>
                    <Row gutter={24}>
                      <Col xs={24} sm={24} md={10} lg={10}>
                        <Form.Item
                          name={[index, "name"]}
                          label="* Tên user::"
                          rules={[
                            {
                              required: true,
                              message: `Vui lòng nhập tên user!`,
                            },
                          ]}
                        >
                          <AutoComplete
                            showSearch
                            onSelect={(value) => this.onSelect(value, index)}
                            onSearch={
                              !phoneUsers[index]?.id ? this.onSearch : undefined
                            }
                            placeholder="Tên user"
                            disabled={!editable || !disable}
                            dataSource={
                              !phoneUsers[index]?.id ? dataSource : []
                            }
                          />
                        </Form.Item>

                        <Form.Item
                          label="* Số điện thoại::"
                          name={[index, "mobile"]}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(rule, v) {
                                if (!v) {
                                  return Promise.reject(
                                    `Vui lòng nhập Số điện thoại!`
                                  );
                                }
                                if (v.length < 12) {
                                  return Promise.reject(
                                    `Số điện thoại không đúng định dạng!`
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <PhoneInput
                            disabled={!editable || !disable}
                            ref={(ref) => (this[`phone${index}`] = ref)}
                            autoFormat={false}
                            placeholder=""
                            countryCodeEditable={false}
                            onChange={(phone) => this.setPhone(phone, index)}
                            country={
                              phoneUsers[index] ? phoneUsers[index].iso2 : "vn"
                            }
                          />
                        </Form.Item>

                        <Form.Item
                          label="* Tài khoản đăng nhập::"
                          name={[index, "username"]}
                          rules={[
                            {
                              required: true,
                              message: "Vui lòng nhập username",
                            },
                          ]}
                        >
                          <Input disabled placeholder="" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={24} md={10} lg={10}>
                        <Form.Item
                          label="* Email::"
                          name={[index, "email"]}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(rule, value) {
                                if (value) {
                                  const listCheck = value.split("@");

                                  if (
                                    value.includes("..") ||
                                    listCheck[0].startsWith(".") ||
                                    listCheck[0].endsWith(".") ||
                                    (listCheck.length > 1 &&
                                      listCheck[1].startsWith(".")) ||
                                    (listCheck.length > 1 &&
                                      listCheck[1].endsWith("."))
                                  ) {
                                    return Promise.reject(
                                      "Vui lòng kiểm tra lại Email!"
                                    );
                                  }
                                  if (
                                    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                                      value
                                    )
                                  ) {
                                    return Promise.resolve();
                                  }
                                  if (value.length > 100) {
                                    return Promise.reject(
                                      "Email vượt quá 100 ký tự!"
                                    );
                                  }
                                  return Promise.reject(
                                    "Vui lòng kiểm tra lại Email!"
                                  );
                                } else {
                                  return Promise.reject(
                                    "Vui lòng nhập địa chỉ Email!"
                                  );
                                }
                              },
                            }),
                          ]}
                        >
                          <Input
                            disabled={!editable || !disable}
                            placeholder=""
                          />
                        </Form.Item>

                        <Form.Item
                          label="* Bộ phận::"
                          name={[index, "department"]}
                          rules={[
                            {
                              required: true,
                              message: `Vui lòng nhập bộ phận!`,
                            },
                          ]}
                        >
                          <Input
                            disabled={!editable || !disable}
                            placeholder=""
                          />
                        </Form.Item>

                        <Form.Item
                          label="* Password::"
                          name={[index, "password"]}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(rule, v) {
                                if (!v) {
                                  return Promise.reject(
                                    `Vui lòng nhập Mật khẩu!`
                                  );
                                }
                                if (
                                  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[~`!@#$%^&*()_\-:"'?/><.,|\\+= ]).{8,100}$/.test(
                                    v
                                  )
                                ) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(
                                  "Mật khẩu không đúng định dạng!"
                                );
                              },
                            }),
                          ]}
                        >
                          <Input
                            type="password"
                            disabled={typeOption === "create_new" || !editable}
                            placeholder=""
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={4} lg={4}>
                        {fields.length > 0 && (
                          <Button
                            className={
                              !editable ||
                              !disable ||
                              (phoneUsers[index] &&
                                phoneUsers[index].isInContract)
                                ? "dynamic-delete-button disable-btn"
                                : "dynamic-delete-button"
                            }
                            disabled={
                              !editable ||
                              !disable ||
                              (phoneUsers[index] &&
                                phoneUsers[index].isInContract)
                            }
                            type="danger"
                            onClick={
                              typeOption !== "edit"
                                ? () => {
                                    remove(field.name);
                                    this.removePhoneUser(index);
                                    debounce(
                                      () => this.props.addUserSuggest(),
                                      100
                                    )();
                                  }
                                : () => {
                                    this.deleteSubUser(index, () => {
                                      remove(field.name);
                                    });
                                  }
                            }
                            icon={<DeleteOutlined />}
                          >
                            Xóa user
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </div>
                ))}
                {phoneUsers.length > 0 && editable ? (
                  <div style={{ color: "#d20a30", marginBottom: "18px" }}>
                    Vui lòng không để trống các trường bắt buộc khi thêm user
                    mới. Nếu bạn không muốn thêm user mới, hãy chọn button xóa
                    user.
                  </div>
                ) : null}
                <Form.Item>
                  <Button
                    disabled={!editable || !disable}
                    className={
                      !editable || !disable
                        ? "add-sub-user-btn disable-btn"
                        : "add-sub-user-btn"
                    }
                    onClick={() => {
                      add();
                      this.addPhoneUser();
                      debounce(() => this.props.addUserSuggest(), 100)();
                    }}
                  >
                    <PlusOutlined /> Add new user
                  </Button>
                </Form.Item>
              </div>
            );
          }}
        </Form.List>
      </>
    );
  }
}
